import { withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Scroll from 'react-scroll';
import compose from 'recompose/compose';

const scroll = Scroll.animateScroll;

const styles = () => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
        // [theme.breakpoints.down('md')]: {
        //     display: 'block',
        // },
        background: '#fff',
    },
});

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (location !== prevProps.location) {
            if (location.pathname !== prevProps.location.pathname) {
                scroll.scrollToTop();
            }
        }
    }

    render() {
        const { classes, children } = this.props;

        return (
            <div className={classes.root}>
                {children}
            </div>
        );
    }
}

export default compose(
    withStyles(styles, { name: 'ScrollToTop' }),
    withRouter,
)(ScrollToTop);
